import { useGlobalState, useResponsive } from '@/hooks';
import { type IWrapper, ResponsiveCollection, WrapperEntryName } from '@/interfaces';
import { capitalize } from '@/utils';
import {
  SectionContainer,
  WrapperSectionContainer,
  WrapperSubText,
  WrapperTitle,
  WrapperTitleUnderline,
} from './Wrapper.styles';
import { BodyComponent, FullWidthComponent } from './WrapperTemplates';

const Wrapper: React.FC<IWrapper> = ({
  title,
  subText,
  backgroundColor,
  subTextMobile,
  entryList,
  content,
  image,
  dataPicker,
  data,
}) => {
  const FULL_WIDTH_ENTRY_NAME = WrapperEntryName.Company; // This is the only case where we want to render the content as full width

  const { t } = useGlobalState();
  const { isMobile } = useResponsive([ResponsiveCollection.Mobile]);

  const translatedTitle = t(title ?? '');
  const translatedSubText = t(subText ?? '');
  const translatedSubTextMobile = t(subTextMobile ?? '');
  const isFullWidthContent = capitalize(entryList?.[0]?.__typename) === FULL_WIDTH_ENTRY_NAME;

  const shouldRenderWrapper = !!(isFullWidthContent || entryList?.length || content || data?.length);

  if (!shouldRenderWrapper) return null;

  const containsDataPicker = !!(!content && !entryList?.length && dataPicker);

  return (
    <WrapperSectionContainer bgColor={backgroundColor} isFullWidthContent={isFullWidthContent}>
      <SectionContainer containsDataPicker={containsDataPicker}>
        {translatedTitle && (
          <>
            <WrapperTitle>{translatedTitle}</WrapperTitle>
            <WrapperTitleUnderline />
          </>
        )}
        {isMobile && translatedSubTextMobile && <WrapperSubText>{translatedSubTextMobile}</WrapperSubText>}
        {!isMobile && translatedSubText && <WrapperSubText>{translatedSubText}</WrapperSubText>}
        {!isFullWidthContent && (
          <BodyComponent data={data} image={image} content={content} entryList={entryList} dataPicker={dataPicker} />
        )}
      </SectionContainer>

      {isFullWidthContent && <FullWidthComponent image={image} entryList={entryList} />}
    </WrapperSectionContainer>
  );
};

export default Wrapper;
